import React from "react";
import { makeStyles, ButtonBase, Typography } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import clsx from "clsx";
import { getLang } from "app/feature/constants";

const useStyle = makeStyles((theme) => ({
  root: {
    padding: "5px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#ECEFF0",
    borderRadius: "4px",
    width: "100%",
    overflow: "hidden",
  },
  inputText: {
    fontSize: "1rem",
    color: "#A4A6A8",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  filled: {
    color: "rgba(0, 0, 0, 0.87)"
  }
}));

export default function CurrencySelectComponent({
  anchorRef,
  handleClick,
  value,
  styles,
  disabled,
  textStyles,
  lang
}) {
  const classes = useStyle();

  const getDisplay = () => {
    let display = getLang(lang, "placeholder.SELECT_CURRENCY");
    if (value.length > 0) {
      display = value.map((item) => item.alpha3 || "").filter(item => !!item).join(", ");
    }
    return display;
  };

  return (
    <ButtonBase
      className={classes.root}
      disableRipple
      ref={anchorRef}
      style={styles}
      onClick={handleClick}
      disabled={disabled}
    >
      <Typography
        variant="body2"
        style={textStyles}
        className={clsx(
          classes.inputText,
          getDisplay() !== getLang(lang, "placeholder.SELECT_CURRENCY") && classes.filled
        )}
      >
        {getDisplay()}
      </Typography>
      <ArrowDropDownIcon fontSize="small" />
    </ButtonBase>
  );
}
